import { useContext } from 'react'

import { SignoutContext } from '~/features/auth/constants'

const useSignoutContext = () => {
  const ctx = useContext(SignoutContext)

  if (!ctx) {
    throw new Error(
      'useSignoutContext must be used within a SignoutContextProvider',
    )
  }

  return ctx
}

export default useSignoutContext
